"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_service.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalResaleServiceUpdateResaleApplicationResponse = exports.LegacyPortalResaleServiceUpdateResaleApplicationRequest = exports.LegacyPortalResaleServiceGetResaleApplicationResponse = exports.LegacyPortalResaleServiceGetResaleApplicationRequest = exports.LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application = exports.LegacyPortalResaleServiceGetMyResaleApplicationsResponse = exports.LegacyPortalResaleServiceGetMyResaleApplicationsRequest = exports.LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound = exports.LegacyPortalResaleServiceGetResaleRoundsResponse = exports.LegacyPortalResaleServiceGetResaleRoundsRequest = exports.LegacyPortalResaleServiceGetResaleListingResponse = exports.LegacyPortalResaleServiceGetResaleListingRequest = exports.LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing = exports.LegacyPortalResaleServiceGetMyResaleListingsResponse = exports.LegacyPortalResaleServiceGetMyResaleListingsRequest = exports.LegacyPortalResaleServiceUpdateResaleListingResponse = exports.LegacyPortalResaleServiceUpdateResaleListingRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const legacy_portal_common_pb_1 = require("./legacy_portal_common_pb");
/**
 * リセール出品更新 API
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingRequest
 */
class LegacyPortalResaleServiceUpdateResaleListingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * リセール回ID
         *
         * @generated from field: string resale_round_id = 1;
         */
        this.resaleRoundId = "";
        /**
         * 更新後の出品ステータス (LISTING: 出品, CANCELED: 出品キャンセル)
         *
         * @generated from field: spwn.resale.v1.LegacyPortalResaleListingStatus status = 2;
         */
        this.status = legacy_portal_common_pb_1.LegacyPortalResaleListingStatus.UNSPECIFIED;
        /**
         * 注文ID
         *
         * @generated from field: string order_id = 3;
         */
        this.orderId = "";
        /**
         * 出品枚数
         *
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceUpdateResaleListingRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceUpdateResaleListingRequest = LegacyPortalResaleServiceUpdateResaleListingRequest;
LegacyPortalResaleServiceUpdateResaleListingRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceUpdateResaleListingRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingRequest";
LegacyPortalResaleServiceUpdateResaleListingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalResaleListingStatus) },
    { no: 3, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingResponse
 */
class LegacyPortalResaleServiceUpdateResaleListingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 更新後の出品リスト
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleListing listings = 1;
         */
        this.listings = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleListingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceUpdateResaleListingResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceUpdateResaleListingResponse = LegacyPortalResaleServiceUpdateResaleListingResponse;
LegacyPortalResaleServiceUpdateResaleListingResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceUpdateResaleListingResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleListingResponse";
LegacyPortalResaleServiceUpdateResaleListingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "listings", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleListing, repeated: true },
]);
/**
 * 自身の出品一覧・状況取得 API
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsRequest
 */
class LegacyPortalResaleServiceGetMyResaleListingsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleListingsRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleListingsRequest = LegacyPortalResaleServiceGetMyResaleListingsRequest;
LegacyPortalResaleServiceGetMyResaleListingsRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleListingsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsRequest";
LegacyPortalResaleServiceGetMyResaleListingsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalResaleListingStatus), opt: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse
 */
class LegacyPortalResaleServiceGetMyResaleListingsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse.Listing listings = 1;
         */
        this.listings = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleListingsResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleListingsResponse = LegacyPortalResaleServiceGetMyResaleListingsResponse;
LegacyPortalResaleServiceGetMyResaleListingsResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleListingsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse";
LegacyPortalResaleServiceGetMyResaleListingsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "listings", kind: "message", T: LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing, repeated: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse.Listing
 */
class LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 3;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_id = 4;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 5;
         */
        this.ticketName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing = LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing;
LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleListingsResponse.Listing";
LegacyPortalResaleServiceGetMyResaleListingsResponse_Listing.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "listing", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleListing },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "round", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleRound },
]);
/**
 * 自身の出品詳細取得 API
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleListingRequest
 */
class LegacyPortalResaleServiceGetResaleListingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 出品ID
         *
         * @generated from field: string resale_listing_id = 1;
         */
        this.resaleListingId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleListingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleListingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleListingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleListingRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleListingRequest = LegacyPortalResaleServiceGetResaleListingRequest;
LegacyPortalResaleServiceGetResaleListingRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleListingRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleListingRequest";
LegacyPortalResaleServiceGetResaleListingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_listing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleListingResponse
 */
class LegacyPortalResaleServiceGetResaleListingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 4;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_id = 5;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 6;
         */
        this.ticketName = "";
        /**
         * 券面価格
         *
         * @generated from field: int32 face_value = 7;
         */
        this.faceValue = 0;
        /**
         * 出品手数料
         *
         * @generated from field: int32 listing_fee = 8;
         */
        this.listingFee = 0;
        /**
         * 受取手数料
         *
         * @generated from field: int32 payout_fee = 9;
         */
        this.payoutFee = 0;
        /**
         * 成立時に返金・受取される予定額
         *
         * @generated from field: int32 payout_amount = 10;
         */
        this.payoutAmount = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleListingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleListingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleListingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleListingResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleListingResponse = LegacyPortalResaleServiceGetResaleListingResponse;
LegacyPortalResaleServiceGetResaleListingResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleListingResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleListingResponse";
LegacyPortalResaleServiceGetResaleListingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "listing", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleListing },
    { no: 2, name: "round", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleRound },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "face_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "listing_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "payout_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "payout_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * リセール回・受付状況一覧取得 API（新規申込用）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsRequest
 */
class LegacyPortalResaleServiceGetResaleRoundsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleRoundsRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleRoundsRequest = LegacyPortalResaleServiceGetResaleRoundsRequest;
LegacyPortalResaleServiceGetResaleRoundsRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleRoundsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsRequest";
LegacyPortalResaleServiceGetResaleRoundsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalResaleRoundStatus), opt: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse
 */
class LegacyPortalResaleServiceGetResaleRoundsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse.ResaleRound resale_rounds = 1;
         */
        this.resaleRounds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleRoundsResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleRoundsResponse = LegacyPortalResaleServiceGetResaleRoundsResponse;
LegacyPortalResaleServiceGetResaleRoundsResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleRoundsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse";
LegacyPortalResaleServiceGetResaleRoundsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_rounds", kind: "message", T: LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound, repeated: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse.ResaleRound
 */
class LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 3;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_id = 4;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 5;
         */
        this.ticketName = "";
        /**
         * 券面価格
         *
         * @generated from field: int32 face_value = 6;
         */
        this.faceValue = 0;
        /**
         * 申込上限枚数
         *
         * @generated from field: int32 max_applicable_quantity = 7;
         */
        this.maxApplicableQuantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound = LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound;
LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleRoundsResponse.ResaleRound";
LegacyPortalResaleServiceGetResaleRoundsResponse_ResaleRound.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "round", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleRound },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "face_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "max_applicable_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "my_application", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleApplication, opt: true },
]);
/**
 * 自身の申込一覧・状況取得 API（マイページ一覧用）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsRequest
 */
class LegacyPortalResaleServiceGetMyResaleApplicationsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleApplicationsRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleApplicationsRequest = LegacyPortalResaleServiceGetMyResaleApplicationsRequest;
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsRequest";
LegacyPortalResaleServiceGetMyResaleApplicationsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalResaleApplicationStatus), opt: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse
 */
class LegacyPortalResaleServiceGetMyResaleApplicationsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse.Application applications = 1;
         */
        this.applications = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleApplicationsResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleApplicationsResponse = LegacyPortalResaleServiceGetMyResaleApplicationsResponse;
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse";
LegacyPortalResaleServiceGetMyResaleApplicationsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applications", kind: "message", T: LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application, repeated: true },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse.Application
 */
class LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 4;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_id = 5;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 6;
         */
        this.ticketName = "";
        /**
         * 券面価格
         *
         * @generated from field: int32 face_value = 7;
         */
        this.faceValue = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application, a, b);
    }
}
exports.LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application = LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application;
LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetMyResaleApplicationsResponse.Application";
LegacyPortalResaleServiceGetMyResaleApplicationsResponse_Application.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleApplication },
    { no: 2, name: "round", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleRound },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "face_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 自身の申込詳細取得 API（申込詳細・変更・キャンセル用）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleApplicationRequest
 */
class LegacyPortalResaleServiceGetResaleApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 申込ID
         *
         * @generated from field: string resale_application_id = 1;
         */
        this.resaleApplicationId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleApplicationRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleApplicationRequest = LegacyPortalResaleServiceGetResaleApplicationRequest;
LegacyPortalResaleServiceGetResaleApplicationRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleApplicationRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleApplicationRequest";
LegacyPortalResaleServiceGetResaleApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceGetResaleApplicationResponse
 */
class LegacyPortalResaleServiceGetResaleApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        /**
         * @generated from field: string event_name = 4;
         */
        this.eventName = "";
        /**
         * @generated from field: string ticket_id = 5;
         */
        this.ticketId = "";
        /**
         * @generated from field: string ticket_name = 6;
         */
        this.ticketName = "";
        /**
         * 券面価格
         *
         * @generated from field: int32 face_value = 7;
         */
        this.faceValue = 0;
        /**
         * 決済予定総額
         *
         * @generated from field: int32 total_payment_amount = 8;
         */
        this.totalPaymentAmount = 0;
        /**
         * 申込上限枚数
         *
         * @generated from field: int32 max_applicable_quantity = 9;
         */
        this.maxApplicableQuantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceGetResaleApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceGetResaleApplicationResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceGetResaleApplicationResponse = LegacyPortalResaleServiceGetResaleApplicationResponse;
LegacyPortalResaleServiceGetResaleApplicationResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceGetResaleApplicationResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceGetResaleApplicationResponse";
LegacyPortalResaleServiceGetResaleApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleApplication },
    { no: 2, name: "round", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleRound },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "face_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "total_payment_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "max_applicable_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * リセール申込更新 API（新規申込・枚数増減・キャンセルを一括処理）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationRequest
 */
class LegacyPortalResaleServiceUpdateResaleApplicationRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * リセール回ID
         *
         * @generated from field: string resale_round_id = 1;
         */
        this.resaleRoundId = "";
        /**
         * 更新後の申込ステータス (APPLIED: 申込・枚数変更, CANCELED: 申込キャンセル)
         *
         * @generated from field: spwn.resale.v1.LegacyPortalResaleApplicationStatus status = 2;
         */
        this.status = legacy_portal_common_pb_1.LegacyPortalResaleApplicationStatus.UNSPECIFIED;
        /**
         * 申込枚数
         *
         * @generated from field: int32 quantity = 3;
         */
        this.quantity = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceUpdateResaleApplicationRequest, a, b);
    }
}
exports.LegacyPortalResaleServiceUpdateResaleApplicationRequest = LegacyPortalResaleServiceUpdateResaleApplicationRequest;
LegacyPortalResaleServiceUpdateResaleApplicationRequest.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceUpdateResaleApplicationRequest.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationRequest";
LegacyPortalResaleServiceUpdateResaleApplicationRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(legacy_portal_common_pb_1.LegacyPortalResaleApplicationStatus) },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationResponse
 */
class LegacyPortalResaleServiceUpdateResaleApplicationResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleServiceUpdateResaleApplicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalResaleServiceUpdateResaleApplicationResponse, a, b);
    }
}
exports.LegacyPortalResaleServiceUpdateResaleApplicationResponse = LegacyPortalResaleServiceUpdateResaleApplicationResponse;
LegacyPortalResaleServiceUpdateResaleApplicationResponse.runtime = protobuf_1.proto3;
LegacyPortalResaleServiceUpdateResaleApplicationResponse.typeName = "spwn.resale.v1.LegacyPortalResaleServiceUpdateResaleApplicationResponse";
LegacyPortalResaleServiceUpdateResaleApplicationResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "application", kind: "message", T: legacy_portal_common_pb_1.LegacyPortalResaleApplication },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map